export const mutations = {
  UPDATE_APPLICATION_SMALL (state, payload) {
    state.small = payload;
  },
  UPDATE_APPLICATION_LARGE (state, payload) {
    state.large = payload;
  },
  UPDATE_ACTIVE_APPLICATION (state, payload) {
    // payload === 'small' or 'large'
    state.activeApplication = payload;
  },
  UPDATE_ADDITIONAL_POSTCODE_FIELDS (state) {
    state.ua_tradingaddresspostcode = state.ua_tradingpostcode;
    state.ua_registeredaddresspostcode = state.ua_registeredpostcode;
  },
  UPDATE_CURRENT_STEP (state, payload) {
    state[state.activeApplication].ua_currentpageinapplication = payload;
  },
  PREFILL_APPLICATION (state, payload) {
    state.ua_businessname = payload.ua_companyname;
    state.ua_maincontactname = `${payload.ua_firstname} ${payload.ua_lastname}`;
    state.ua_maincontacttelephone = payload.ua_preferredcontacttelephoneno;
    state.ua_maincontactemail = payload.ua_emailaddress;
    state.ua_tradingaddress = payload.ua_tradingaddressline1;
    state.ua_tradingaddressline2 = payload.ua_tradingaddressline2;
    state.ua_tradingaddresstowncity = payload.ua_tradingaddresstowncity;
    state.ua_tradingaddresspostcode = payload.ua_tradingaddresspostcode;
    state.ua_tradingpostcode = payload.ua_tradingpostcodefromryi;
    state.ua_tradingaddresssameasregistered = payload.ua_registeredaddresssameastrading;
    state.ua_registeredaddress = payload.ua_registeredaddressline1;
    state.ua_registeredaddressline2 = payload.ua_registeredaddressline2;
    state.ua_registeredaddresstowncity = payload.ua_registeredaddresstowncity;
    state.ua_registeredaddresspostcode = payload.ua_registeredaddresspostcode;
    state.ua_registeredpostcode = payload.ua_registeredpostcodefromryi;
    state.ua_legalstatus = payload.ua_typeofbusinessownership;
    state.ua_legalstatusother = payload.ua_businessownershipother;
    state.ua_companyregistrationnumber = payload.ua_companyregistrationnumber;
    state.ua_datebusinessstartedtrading = payload.ua_datestartedtrading;
    state.ua_uniquetaxreferencenumber = payload.ua_utrnumber;
    state.ua_dateregisteredwithhmrc = payload.ua_dateregisteredwithhmrc;
    state.ua_sectorparentlookup = payload.ua_sectorparentlookup;
    state.ua_sector = payload.ua_sectornamefromryi;
    state.ua_sectorlookup = payload.ua_umisector;
    state.ua_lastapprovedturnover = payload.ua_annualturnover;
    state.ua_financialyearenddate = payload.ua_financialyearend;
    state.ua_lastapprovedemployees = payload.ua_numberofemployees;
    state.ua_isthebusinesspartofagroup = payload.ua_partofgroup === true ? 1 : 2;
    state.ua_businessoverview = payload.ua_whatdoesthebusinessdo;
    state.ua_describeproposal = payload.ua_enquirydetails;
    state.ua_haveregisteredcharitystatus = payload.ua_haveregisteredcharitystatus;
    state.ua_registeredonmutualsregister = payload.ua_registeredonmutualsregister;
    state.ua_mutualsregisterregistrationnumber = payload.ua_mutualsregisterregistrationnumber;
  }
};
